'use strict';/* global define, console */define('modules/download/constants/default-feedback-fields/index',['require','exports','module'],function(require,exports,module){'use strict';module.exports=['user','feedbackPeriod'];});
